import { SxProps, TextField } from '@mui/material';
import { FastField } from 'formik';
import _ from 'lodash';
import { FC } from 'react';
import { getFormikValueWithSubFields } from 'src/util/utils';
import { InputFieldConditionalRendering } from '../conditional-rendering/InputFieldConditionalRendering';

interface TextAreaFieldProps {
  label: string;
  fieldName: string;
  formik?: any;
  placeholder?: string;
  disabled?: boolean;
  fieldList?: string[];
  hideHelperText?: boolean;
  sx?: SxProps;
  endAdornment?: React.ReactNode;
}

export const DefaultTextAreaField: FC<TextAreaFieldProps> = ({
  label,
  fieldName,
  formik,
  placeholder,
  disabled,
  fieldList,
  hideHelperText,
  sx,
  endAdornment,
}) => {
  let fieldValue, fieldTouched, fieldError;
  if (fieldList) {
    fieldValue = getFormikValueWithSubFields(formik.values, fieldList);
    fieldTouched = getFormikValueWithSubFields(formik.touched, fieldList);
    fieldError = getFormikValueWithSubFields(formik.errors, fieldList);
  } else {
    fieldValue = _.get(formik.values, fieldName);
    fieldTouched = _.get(formik.touched, fieldName);
    fieldError = _.get(formik.errors, fieldName);
  }
  return (
    <TextField
      margin="normal"
      label={label}
      {...formik.getFieldProps(fieldName)}
      type="text"
      variant="outlined"
      placeholder={placeholder}
      disabled={disabled}
      fullWidth
      sx={sx}
      /* Empty string as fallback, otherwise the label won't shrink on programmatic value change. */
      value={fieldValue || ''}
      onChange={formik.handleChange}
      error={fieldTouched && Boolean(fieldError)}
      helperText={!hideHelperText ? (fieldTouched && fieldError) ?? ' ' : ''}
      multiline
      inputProps={{ 'data-cy': fieldName + '-field' }}
      InputProps={{ endAdornment }}
      rows={4}
    />
  );
};

export const DefaultFastTextAreaField: FC<TextAreaFieldProps> = ({ label, fieldName, placeholder, disabled, hideHelperText }) => {
  return (
    <InputFieldConditionalRendering fieldName={fieldName}>
      <FastField name={fieldName}>
        {(input: any) => {
          const { field, form } = input;
          return (
            <TextField
              margin="normal"
              label={label}
              variant="outlined"
              fullWidth
              disabled={disabled}
              placeholder={placeholder}
              error={form.touched[fieldName] && Boolean(form.errors[fieldName])}
              helperText={!hideHelperText ? (form.touched[fieldName] && form.errors[fieldName]) ?? ' ' : ''}
              multiline
              rows={4}
              inputProps={{ 'data-cy': fieldName + '-field' }}
              {...field}
            />
          );
        }}
      </FastField>
    </InputFieldConditionalRendering>
  );
};
